export enum ConversationDataIndex {
  sent_by = 'sent_by',
  content = 'content',
  sent_at = 'sent_at',
  actions = 'actions',
}
